@if (selections().length) {
    <action-bar-pds3 [dividerIndexes]="[2]">
        <div *actionBarSelectedInfoPds3 class="wk-data-table__actionbar-selected-info">
            <sr-only-pds3>{{ selections().length }} {{ "DataTable.Selected" | wkTranslate }}</sr-only-pds3>
            <span aria-hidden="true"> {{ selections().length }} {{ "DataTable.Selected" | wkTranslate }} </span>
            <icon-pds3 name="wk-icon-close" (click)="clearAll()" />
        </div>

        @for (action of dataTableContext.actions()(); track $index) {
            @if (action && action.visibleOnSelectedItems) {
                <div *actionBarItemPds3>
                    <action-bar-button-field-pds3>
                        <button
                            class="wk-data-table__action-button"
                            [class]="`wk-data-table__action-button--${action.type.toLowerCase()}`"
                            type="button"
                            (click)="action.selectionEvent?.(selections())"
                        >
                            <icon-pds3 [name]="`wk-icon-${action.icon}`" />
                            <span>{{ typeof action.title === "function" ? action.title() : (action.title | wkTranslate) }}</span>
                        </button>
                    </action-bar-button-field-pds3>
                </div>
            }
        }
    </action-bar-pds3>
}
